import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import moment from "moment";
import { constants } from "../../constants/constants";
import { NotificationTypeInputs } from "../../components/MobileNotification/NotificationToggle";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { uploadData } from "../../utils/ApiCalls/Upload";
import { MenuItem, Select } from "@mui/material";
import {
  updateNotification,
  createNotifications,
} from "../../utils/ApiCalls/Mobile/Notification";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { checkFields } from "../../utils/Validation/checkFields";
import UploadFile from "./UploadFile";
import SailingDropdown from "./TargetShipsSailingSelector";
import NotificationTitleInput from "./NotificationTitleInput";
import NotificationContentInput from "./NotificationContentInput";
import ErrorPopup from "../mobile/popup/ErrorPopup";
import {
  NotificationTypeToggle,
  ContentTypeMap,
  NotificationCategory,
  NotificationType,
} from "./NotificationToggle";
import { addlog } from "../../utils/ApiCalls/Logs";

import { ScheduleComponents } from "./Schedule";
import DateAndTimePickerNotification from "../DateAndTimePicker/notificationDateTimePicker";
import { LOG_ACTIONS, LOG_TYPES } from "../../utils/Constant/LogConstant";


const CreateMobileNotificationInput = ({
  notificationData,
  sailingData,
  vesselData,
  readOnly,
}) => {
  const [title, setTitle] = useState("");
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState("");
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState("");

  const [contentType, setContentType] = useState("text");
  const [type, setType] = useState("in-app");
  const [categoryType, setCategoryType] = useState("notification");

  const [previewContent, setPreviewContent] = useState("");
  const [simplifiedChinesePreviewContent, setSimplifiedChinesePreviewContent] =
    useState("");
  const [
    traditionalChinesePreviewContent,
    setTraditionalChinesePreviewContent,
  ] = useState("");

  const [content, setContent] = useState("");
  const [simplifiedChineseContent, setSimplifiedChineseContent] = useState("");
  const [traditionalChineseContent, setTraditionalChineseContent] =
    useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedSCFile, setSelectedSCFile] = useState(null);
  const [selectedTCFile, setSelectedTCFile] = useState(null);

  const [isScheduled, SetIsScheduled] = useState(0);
  const [notificationDate, setNotificationDate] = useState("");
  const [notificationTime, setNotificationTime] = useState("");
  const [packageId, setPackageId] = useState("");
  const [sailingDate, setSailingDate] = useState("");
  const [{ userDetails }, dispatch] = useDataLayerValue();

  const [validFrom, setValidFrom] = useState(null);
  const [validTo, setValidTo] = useState(null);
  const [isActive, setIsActive] = useState(1);
  const [vesselId, setVesselId] = useState(1);

  const [vesselOptions, setVesselOptions] = useState([]);

  const [vessel, setVessel] = useState([]);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const addNotificationData = async (e) => {
    e.preventDefault();
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    // Compute current date/time if not scheduled
    let currentDate = "";
    let currentTime = "";
    if (!isScheduled) {
      const now = new Date();
      currentDate = now.toISOString().slice(0, 10); // YYYY-MM-DD
      const pad = (num) => String(num).padStart(2, "0");
      currentTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
        now.getSeconds()
      )}`;
    }

    // Use local variables instead of relying on state
    const notificationDateValue = isScheduled ? notificationDate : currentDate;
    const notificationTimeValue = isScheduled ? notificationTime : currentTime;

    let dataValues = {
      title,
      simplifiedChineseTitle,
      traditionalChineseTitle,
      type,
      contentType,
      categoryType,
      content,
      simplifiedChineseContent,
      traditionalChineseContent,
      previewContent,
      simplifiedChinesePreviewContent,
      traditionalChinesePreviewContent,
      media: selectedFile,
      simplifiedChineseMedia: selectedSCFile,
      traditionalChineseMedia: selectedTCFile,
      isScheduled,
      notificationDate: notificationDateValue,
      notificationTime: notificationTimeValue,
      packageId,
      sailingDate,
      validFrom,
      validTo,
      isActive,
    };
    let valid = checkFields(dataValues);

    if (selectedFile) {
      if (typeof selectedFile === "string") {
        dataValues.media = selectedFile.replace(constants.MEDIAURL + "/", "");
      } else {
        let media = await uploadData(selectedFile, undefined, typeof notificationData?.media === 'string' ? notificationData.media : null);
        if (media?.error) throw new Error(media.error);

        dataValues.media = media?.url;
      }
    } else {
      dataValues.media = "";
    }
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      let data;
      if (notificationData?.id) {
        data = await updateNotification(notificationData?.id, {
          ...dataValues,
        });
      } else {
        data = await createNotifications({ ...dataValues });
      }

      if (data?.error) {
        throw new Error(data.error);
      } else {
        if (notificationData?.id) {
           addlog(
            LOG_ACTIONS.UPDATED,
            LOG_TYPES.NOTIFICATIONS,
            {
              id: notificationData.id,
              title: `${title} Notification`,
              values: data?.data,
            },
            userDetails.id
          );
        } else {
          addlog(
            LOG_ACTIONS.CREATED,
            LOG_TYPES.NOTIFICATIONS,
            { id: data?.data.id, title: `${title} Notification`, values: data?.data },
            userDetails.id
          );
        }
      }

      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        return;
      }
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      if (!notificationData?.id) {
        navigate(`/shore/notifications${location.search}`);
      } else {
        navigate(`/shore/notifications${location.search}`);
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
      }

    }
  };

  const handleUpdate = async () => {
    // await addParentCat({ parentCat: parentCat, vessel });
    // setOpen(false);
  };

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();

    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  useEffect(() => {
    if (notificationData) {
      setSelectedFile(notificationData?.media);
      setSelectedSCFile(notificationData?.simplifiedChineseMedia);
      setSelectedTCFile(notificationData?.traditionalChineseMedia);

      setTitle(notificationData?.title);
      setSimplifiedChineseTitle(notificationData?.simplifiedChineseTitle);
      setTraditionalChineseTitle(notificationData?.traditionalChineseTitle);

      setContent(notificationData?.content);
      setSimplifiedChineseContent(notificationData?.simplifiedChineseContent);
      setTraditionalChineseContent(notificationData?.traditionalChineseContent);

      setPreviewContent(notificationData?.previewContent);
      setSimplifiedChinesePreviewContent(
        notificationData?.simplifiedChinesePreviewContent
      );
      setTraditionalChinesePreviewContent(
        notificationData?.traditionalChinesePreviewContent
      );

      setContentType(notificationData?.contentType);
      SetIsScheduled(notificationData?.isScheduled);
      setNotificationDate(notificationData?.notificationDate);
      setNotificationTime(notificationData?.notificationTime);
      setCategoryType(notificationData?.categoryType);
      setType(notificationData?.type);
      setPackageId(notificationData?.packageId);
      setSailingDate(notificationData?.sailingDate);
      setValidFrom(notificationData?.validFrom);
      setValidTo(notificationData?.validTo);
      setIsActive(notificationData?.isActive);

      if (Array.isArray(vesselData)) {
        setVessel(vesselData?.map((item) => item.vessel_id));
      }
    }
  }, [notificationData, vesselData]);

  useEffect(() => {
    getOptionLocation();
  }, []);

  return (
    <div>
      <ErrorPopup
        open={open}
        setOpen={setOpen}
        title={"Missing Record"}
        message={message}
        buttonTitle={"Add Missing Data "}
        handleUpdate={handleUpdate}
      />
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addNotificationData}>
              <fieldset
                disabled={readOnly}
                style={{ opacity: readOnly ? 0.6 : 1 }}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationTitleInput
                          label="English Notification Title"
                          value={title}
                          onChange={setTitle}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationTitleInput
                          label="Simplified Chinese Notification Title"
                          value={simplifiedChineseTitle}
                          onChange={setSimplifiedChineseTitle}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationTitleInput
                          label="Traditional Chinese Notification Title"
                          value={traditionalChineseTitle}
                          onChange={setTraditionalChineseTitle}
                          required={true}
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">Notification Category</label>
                        <NotificationTypeInputs
                          selectedValue={categoryType} // 👈 single value, e.g. "alert"
                          options={NotificationCategory} // 👈 the list of options
                          setSelectedValue={setCategoryType} // 👈 setter function
                          style={{ width: "100%", height: "45px" }}
                          locationType="DisplayLocation" // optional, if you want "required"
                          disabled={false}
                        />
                      </div>
                    </div>

                    {/* <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Notification Type</label>
                      <NotificationTypeInputs
                        selectedValue={type} // 👈 single value, e.g. "alert"
                        options={NotificationType} // 👈 the list of options
                        setSelectedValue={setType} // 👈 setter function
                        style={{ width: "100%", height: "45px" }}
                        locationType="DisplayLocation" // optional, if you want "required"
                        disabled={false}
                      />
                    </div>
                  </div> */}
                    {/* 
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <NotificationTypeToggle
                        value={contentType}
                        onChange={setContentType}
                      />
                    </div>
                  </div> */}

                    <div className="w-100"></div>
                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationTitleInput
                          label="English Notification Content Preview"
                          value={previewContent}
                          onChange={setPreviewContent}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationTitleInput
                          label="Simplified Chinese Content Preview"
                          value={simplifiedChinesePreviewContent}
                          onChange={setSimplifiedChinesePreviewContent}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationTitleInput
                          label="Traditional Chinese Content Preview"
                          value={traditionalChinesePreviewContent}
                          onChange={setTraditionalChinesePreviewContent}
                          required={true}
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationContentInput
                          label="English Notification Content"
                          value={content}
                          onChange={setContent}
                          modules={modules}
                          formats={formats}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationContentInput
                          label="Simplified Chinese Notification Content"
                          value={simplifiedChineseContent}
                          onChange={setSimplifiedChineseContent}
                          modules={modules}
                          formats={formats}
                        />
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="fieldrow">
                        <NotificationContentInput
                          label="Traditional Chinese Notification Content"
                          value={traditionalChineseContent}
                          onChange={setTraditionalChineseContent}
                          modules={modules}
                          formats={formats}
                        />
                      </div>
                    </div>

                    {/*                   
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        English Notification Content
                      </label>
                      <ReactQuill
                        value={content}
                        onChange={(e) => {
                          setContent(e);
                        }}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Notification Content
                      </label>
                      <ReactQuill
                        value={simplifiedChineseContent}
                        onChange={(e) => {
                          setSimplifiedChineseContent(e);
                        }}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Notification Content
                      </label>
                      <ReactQuill
                        value={traditionalChineseContent}
                        onChange={(e) => {
                          setTraditionalChineseContent(e);
                        }}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div> */}

                    {/* {contentType !== "text" && (
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <UploadFile
                        mandatory="*"
                        width={164}
                        height={110}
                        type={contentType}
                        image={
                          notificationData?.media?.en
                            ? `${constants.MEDIAURL}/${notificationData.media.en}`
                            : null
                        }
                        label={`Upload ${ContentTypeMap[contentType]} - English`}
                        placeholder={`Upload Notification ${ContentTypeMap[contentType]} - English`}
                        selectedFile={selectedFile}
                        setSelectedFile={setSelectedFile}
                      />
                    </div>
                  )}

                  {contentType !== "text" && (
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <UploadFile
                        mandatory="*"
                        width={164}
                        height={110}
                        type={contentType}
                        image={
                          notificationData?.media?.zh
                            ? `${constants.MEDIAURL}/${notificationData.media.zh}`
                            : null
                        }
                        label={`Upload ${ContentTypeMap[contentType]} - Simplified Chinese`}
                        placeholder={`Upload Notification ${ContentTypeMap[contentType]} - Simplified Chinese`}
                        selectedFile={selectedSCFile}
                        setSelectedFile={setSelectedSCFile}
                      />
                    </div>
                  )}

                  {contentType !== "text" && (
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <UploadFile
                        mandatory="*"
                        width={164}
                        height={110}
                        type={contentType}
                        image={
                          notificationData?.media?.zhTW
                            ? `${constants.MEDIAURL}/${notificationData.media.zhTW}`
                            : null
                        }
                        label={`Upload ${ContentTypeMap[contentType]} - Traditional`}
                        placeholder={`Upload Notification ${ContentTypeMap[contentType]} - Traditional`}
                        selectedFile={selectedTCFile}
                        setSelectedFile={setSelectedTCFile}
                      />
                    </div>
                  )} */}

                    <div className="col-lg-8 col-md-6 col-sm-6 col-6">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div className="fieldrow" style={{ width: "!00%" }}>
                            <label className="f_label">Valid From</label>
                            <DateAndTimePickerNotification
                              value={validFrom}
                              setValue={(e) => {
                                setValidFrom(e);
                                setValidTo("");
                              }}
                              // min={moment(new Date()).format("YYYY-MM-DD")}
                              type="date"
                              className="f_input"
                              // is24HourFormat={true}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                          <div className="fieldrow">
                            <label className="f_label">Valid To</label>
                            <DateAndTimePickerNotification
                              value={validTo}
                              setValue={(e) => setValidTo(e)}
                              // min={moment(validFrom).format("YYYY-MM-DD")}
                              type="date"
                              className="f_input"
                              // is24HourFormat={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-100"></div>
                    {sailingData.length > 0 && (
                      <div className="col-4">
                        <label className="f_label">Target Sailing/User</label>
                        <SailingDropdown
                          sailingData={sailingData}
                          packageId={packageId}
                          setPackageId={setPackageId}
                          sailingDate={sailingDate}
                          setSailingDate={setSailingDate}
                        />
                      </div>
                    )}

                    {/* )} */}

                    <div className="w-100"></div>
                    <div className="col-4">
                      <div className="fieldrow">
                        <label className="f_label">Schedule for later</label>
                        <ScheduleComponents
                          scheduleLater={isScheduled}
                          setScheduleLater={SetIsScheduled}
                          scheduledDate={notificationDate}
                          setScheduledDate={setNotificationDate}
                          scheduledTime={notificationTime}
                          setScheduledTime={setNotificationTime}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="iti_inner">
                        <div className="icheck-primary d-inline">
                          <input
                            type="checkbox"
                            id="customCheckbox4"
                            name="r10"
                            checked={isActive === 1}
                            onChange={() => setIsActive(isActive === 1 ? 0 : 1)}
                          />
                          <label htmlFor="customCheckbox4">
                            {isActive === 1 ? (
                              <p>
                                <span style={{ fontWeight: 600 }}>Active</span>
                              </p>
                            ) : (
                              <p>
                                <span style={{ fontWeight: 200 }}>Active</span>
                              </p>
                            )}
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* 
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Target Sailing</label>
                      <NotificationTypeInputs
                        selectedValue={vessel}
                        // disabled={banner.id}
                        options={vesselOptions}
                        setSelectedValue={(e) => {
                          setVessel(e);
                        }}
                        style={{ width: "100%", height: "45px" }}
                        value={vessel}
                        onChange={(e) => handleLocationChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Target Sailing</label>
                      <NotificationTypeInputs
                        selectedValue={vessel}
                        // disabled={banner.id}
                        options={vesselOptions}
                        setSelectedValue={(e) => {
                          setVessel(e);
                        }}
                        style={{ width: "100%", height: "45px" }}
                        value={vessel}
                        onChange={(e) => handleLocationChange(e)}
                      />
                    </div>
                  </div> */}
                  </div>
                </div>
                <div className="card-footer text-right">
                  <button className="btn main_submit">
                    {notificationData?.id
                      ? isScheduled
                        ? "Update Notification"
                        : "Send Now"
                      : isScheduled
                      ? "Save Notification"
                      : "Send Now"}
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default CreateMobileNotificationInput;
